<template>
  <span :class="classes">{{ payment.type }}</span> &nbsp;
  <PaymentMethodDisplay v-if="payment.payment_method" :payment_method="payment.payment_method"/>
  <span v-if="payment.check_number" :class="classes">: {{ payment.check_number }}</span>
  <span v-if="payment.notes" :class="classes"> - {{ payment.notes }}</span>
</template>

<script>
  import PaymentMethodDisplay from '@/Components/Transaction/PaymentMethodDisplay'

  export default {
  components: {
    PaymentMethodDisplay,
  },
    props: {
      payment: Object,
    },
  }
</script>